import React from 'react';
import './App.css';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import SearchAndFilter from './SearchAndFilter';
import {Select, Input, Slider} from 'antd/lib'
import 'antd/dist/antd.css';
import {Row, Col} from 'react-bootstrap';


class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subject: 'All',
      search: '',
      interested: 'All',
      minimumCredits: "0",
      maximumCredits: "6"
    }
    this.searchAndFilter = new SearchAndFilter();
  }

  setCourses() {
    if(this.state.subject != null && this.state.minimumCredits != null && this.state.maximumCredits != null) {
      this.props.setCourses(this.searchAndFilter.searchAndFilter(this.props.courses,this.state.search, this.state.subject, this.state.interested ,this.state.minimumCredits, this.state.maximumCredits));
    }
  }

  handleCreditsKeyDown(e) {
    if(['0','1','2','3','4','5','6','7','8','9','Backspace','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Tab'].indexOf(e.key) === -1)
      e.preventDefault();
  }

  getSubjectOptions() {
    let subjectOptions = [];

    for(const subject of this.props.subjects) {
      subjectOptions.push(<option key={subject}>{subject}</option>);
    }

    return subjectOptions;
  }
  
  getInterestedOptions() {
    let interestedOptions = [];
    let interestedOptionsList = [];

    for(const course of this.props.courses) {
      for(const keyword of course.keywords) {
        if(!interestedOptions.includes(keyword)) {
          interestedOptions.push(keyword);
        }
      }
    }

    interestedOptions.sort();
    interestedOptions.splice(0, 0, 'All');

    for(const keyword of interestedOptions) {
      interestedOptionsList.push(<option key={keyword}>{keyword}</option>);
    }

    return interestedOptionsList;
  }

  render() {
    return (
      <>
        <Card 
          style={{"border": 'none', width: '100%'}}
        >
          <Card.Body>
            <Form>
              <Row>
                <Col>
                  <Input
                    placeholder="Search"
                    style={{width: "100%", 'outlineWidth': '0px',"boxShadow": '0 1px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)', 'marginBottom': '10px'}}
                    bordered={false}
                    onMouseOver={(evt)=> {
                      evt.target.style.boxShadow = '0 1px 15px rgba(0,0,0,0.3), 0 3px 6px rgba(0,0,0,0.23)';
                    }}
                    onMouseLeave={(evt)=> {
                      evt.target.style.boxShadow = '0 1px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)';
                    }}
                    onChange={async (val) => {
                      await this.setState({search: val.target.value});
                      this.setCourses();
                    }}
                  >
                  </Input>
                </Col>

                <Col>
                  <Select
                    placeholder="Subjects"
                    style={{width: "100%",'outlineWidth': '0px',"boxShadow": '0 1px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)', 'marginBottom': '10px'}}
                    onMouseEnter={(evt)=> {
                      evt.currentTarget.style.boxShadow = '0 1px 15px rgba(0,0,0,0.3), 0 3px 6px rgba(0,0,0,0.23)';
                    }}
                    onMouseLeave={(evt)=> {
                      evt.currentTarget.style.boxShadow = '0 1px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)';
                    }}
                    bordered={false}
                    allowClear={true}
                    onSelect={async (val) => {
                      await this.setState({subject:val})
                      this.setCourses();
                    }}
                    onClear={ async () => {
                      await this.setState({subject: 'All'})
                      this.setCourses();
                    }
                    }
                  >
                    {this.getSubjectOptions().map(item => (
                      <Select.Option key={item.key} value={item.key}>
                        {item.key}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>

                <Col>
                  <Select
                    placeholder="Interests"
                    style={{width: "100%",'outlineWidth': '0px',"boxShadow": '0 1px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)', 'marginBottom': '10px'}}
                    onMouseEnter={(evt)=> {
                      evt.currentTarget.style.boxShadow = '0 1px 15px rgba(0,0,0,0.3), 0 3px 6px rgba(0,0,0,0.23)';
                    }}
                    onMouseLeave={(evt)=> {
                      evt.currentTarget.style.boxShadow = '0 1px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)';
                    }}
                    bordered={false}
                    allowClear={true}
                    onSelect={async (val) => {
                      await this.setState({interested:val})
                      this.setCourses();
                    }}
                    onClear={async () => {
                      await this.setState({interested: "All"});
                      this.setCourses();
                    }}
                  >
                      {this.getInterestedOptions().map(item => (
                      <Select.Option key={item.key} value={item.key}>
                        {item.key}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>

                <Col>
                  <div style={{display: 'inline-flex', width: '100%', alignContent: 'center'}}>
                    <p style={{fontWeight: 'bold', display: 'inline-block', marginRight: '10%'}}>Credits: </p>
                    <Slider style={{display: 'inline-block', width: '50%'}}
                      range defaultValue={[1,6]} min={1} max={6} 
                      onAfterChange={async (val) => {
                        await this.setState({minimumCredits: val[0]+""});
                        await this.setState({maximumCredits: val[1]+""})
                        this.setCourses();
                      }}
                    >
                    </Slider>
                  </div>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      </>
    )
  }
}

export default Sidebar;
